import { useEffect } from "react";

const CART_PREFILL_TTL_MS = 5 * 60 * 1000; // 5 minutes

export function useCartPrefill(setCart) {
  useEffect(() => {
    const prefillKey = "kaiso_duplicate_cart_prefill";
    const raw = localStorage.getItem(prefillKey);

    if (!raw) return;

    try {
      const data = JSON.parse(raw);

      // Check TTL: discard if older than 5 minutes
      if (data.timestamp) {
        const now = Date.now();
        if (now - data.timestamp > CART_PREFILL_TTL_MS) {
          localStorage.removeItem(prefillKey);
          return;
        }
      }

      const items = data.items || [];
      if (!Array.isArray(items) || items.length === 0) {
        localStorage.removeItem(prefillKey);
        return;
      }

      // Set cart with prefilled items
      setCart(items);

      // Remove key after consuming
      localStorage.removeItem(prefillKey);
    } catch (err) {
      // Invalid JSON — ignore and remove key
      localStorage.removeItem(prefillKey);
    }
  }, [setCart]);
}
